if (!customElements.get("m-product-size-chart")) {
  customElements.define(
    "m-product-size-chart",
    class MProductSizeChart extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          openButton: "[data-open-size-chart]",
          content: ".m-product-size-chart__content"
        };
      }

      connectedCallback() {
        this.domNodes = queryDomNodes(this.selectors, this);
        if (this.domNodes.content && this.domNodes.content.innerHTML) {
          this.content = this.domNodes.content.innerHTML;
          this.modal = new MinimogTheme.Modal();
          this.init();
        }
      }

      init() {
        const button = this.domNodes.openButton;
        if (button) {
          button.addEventListener("click", (e) => {
            e.preventDefault();
            this.open();
          });
        }
      }

      open() {
        if (this.content) {
          const html = document.createElement("DIV");
          html.innerHTML = this.content;
          this.modal.appendChild(html);
          this.modal.setWidth("800px");
          this.modal.setSizes("m-product-size-chart__modal");
          this.modal.open();
        }
      }
    }
  );
}
